/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect} from 'react';
import imagePlug from '../../../../../_metronic/assets/media/user.png';
import root from 'react-shadow';
import classNames from 'classnames';
import numeral from 'numeral';
import moment from 'moment';
import arrow_drop_down_gray from './other/arrow_drop_down_gray.svg';
import arrow_drop_down_green from './other/arrow_drop_down_green.svg';
import arrow_forward from './other/arrow_forward.svg';
import bask from './other/bask.webp';
import chevron_left from './other/chevron_left.svg';
import chevron_right from './other/chevron_right.svg';
import close from './other/close.webp';
import cloud from './other/cloud.webp';
import help from './other/help.svg';
import info from './other/info.svg';
import keyboard_arrow_down from './other/keyboard_arrow_down.svg';
import keyboard_arrow_up from './other/keyboard_arrow_up.svg';
import laptop_windows from './other/laptop_windows.svg';
import phone from './other/phone.svg';
import play_arrow from './other/play_arrow.svg';
import search from './other/search.svg';
import share from './other/share.webp';
import teen from './other/teen.webp';
import user from './other/user.webp';
import dots from './other/dots.svg';

const GoogleplaySite = ({data, currentLang, id}) => {
  useEffect(() => {}, [data]);

  useEffect(() => {
    moment.locale(currentLang);
  }, [currentLang]);

  return (
    <>
      <div style={{position: 'relative'}}>
        <root.div>
          <div
            className='body'
            dir={data[currentLang]?.rtl ? 'rtl' : ''}
            style={{overflow: 'auto'}}
          >
            <div className='uiContainer' style={{display: 'block'}}>
              <header className='Layout_header__-fzjb'>
                <section className='Layout_logo__WLWHd'>
                  <svg
                    className='kOqhQd'
                    aria-hidden='true'
                    viewBox='0 0 40 40'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path fill='none' d='M0,0h40v40H0V0z'></path>
                    <g>
                      <path
                        d='M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z'
                        fill='#EA4335'
                      ></path>
                      <path
                        d='M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z'
                        fill='#FBBC04'
                      ></path>
                      <path
                        d='M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z'
                        fill='#4285F4'
                      ></path>
                      <path
                        d='M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z'
                        fill='#34A853'
                      ></path>
                    </g>
                  </svg>
                  <div className='Layout_logo__title__qQBs1'>Google Play</div>
                </section>
                <nav className='Layout_navBar__Wo-Ue'>
                  <ul className='Layout_navBar__list__a5aCz'>
                    <li className='Layout_navBar__item__3f3Xc navBarItem'>Games</li>
                    <li className='Layout_navBar__item__3f3Xc navBarItem Layout__active__pkDw'>
                      Apps
                    </li>
                    <li className='Layout_navBar__item__3f3Xc navBarItem'>Movies &amp; TV</li>
                    <li className='Layout_navBar__item__3f3Xc navBarItem'>Books</li>
                    <li className='Layout_navBar__item__3f3Xc navBarItem'>Kids</li>
                  </ul>
                  <div
                    className='Layout_pointer__2IrZF'
                    style={{transform: 'translateX(94px)', width: '33px'}}
                  ></div>
                </nav>
                <section className='Layout_actions__vGVVH'>
                  <button className='Layout_search__i-X4s'>
                    <img src={search} />
                  </button>
                  <button className='Layout_search__i-X4s'>
                    <img src={help} />
                  </button>
                  <button className='Layout_search__i-X4s'>
                    <img src={user} className='Layout_img__J7ivY' />
                  </button>
                </section>
              </header>
              <section className='BodyHedaer_container__4jlbL'>
                <div className='contentContainer BodyHedaer_contentContainer__6We-0'>
                  <div className='BodyHedaer_trailerWrapper__WOAji'>
                    <button className='BodyHedaer_trailer__QraXM'>
                      <img src={play_arrow} />
                      <div id='btnTrailer1'>{data[currentLang]?.buttons?.trailer}</div>
                    </button>
                  </div>
                  <div className='BodyHedaer_videoContainer__m96AP'>
                    <video
                      className='BodyHedaer_videoContainer__video__Irpty js-parse-mncpkpjgigpklafbenkddfcgalikldde'
                      href={data[currentLang]?.video}
                      muted=''
                      loop=''
                      preload='auto'
                      style={{backgroundImage: `url(https://api.raulnk.com/${id}/images/icons/${currentLang}/${data[currentLang]?.appIcon})`}}
                    ></video>
                    <div className='BodyHedaer_videoContainer__shadow__kkeFR'></div>
                  </div>
                  <div className='BodyHedaer_descriptionsContainer__9BTe'>
                    <div className='BodyHedaer_descriptionsContainer__titles__SXRwG'>
                      <div
                        style={
                          !!data[currentLang]?.appIcon
                            ? {
                                backgroundImage: `url(https://api.raulnk.com/${id}/images/icons/${currentLang}/${data[currentLang]?.appIcon})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                              }
                            : {
                                backgroundImage: `url(${imagePlug})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                              }
                        }
                        className='BodyHedaer_descriptionsContainer__image__7HrCk'
                      />
                      <div className='BodyHedaer_descriptionsContainer__description__qIc72'>
                        <h1>{data[currentLang]?.appName || 'App name'}</h1>
                        <div className='BodyHedaer_descriptionsContainer__developers__jCfxH'>
                          <div className='BodyHedaer_descriptionsContainer__developers__name__8UzSw'>
                            <div>{data[currentLang]?.developer}</div>
                          </div>
                          <div className='BodyHedaer_descriptionsContainer__developers__contacts__nSITA'>
                            <div id='headerSubtitle_1'>
                              {data[currentLang]?.inscriptions?.contains_1}
                            </div>
                            <div id='headerSubtitle_2'>
                              {data[currentLang]?.inscriptions?.contains_2}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='BodyHedaer_descriptionsContainer__downloadsWrapper__xK1Hm'>
                      <div className='BodyHedaer_descriptionsContainer__downloads__Yqvyf'>
                        <div className='BodyHedaer_downloads__ratingWrapper__-LcJP'>
                          <div className='BodyHedaer_downloads__ratingWrapper__stat__tqZWn'>
                            <div className='BodyHedaer_downloads__ratingWrapper__statTitle__Hh11i'>
                              <div>
                                <div className='BodyHedaer_downloads__ratingWrapper__starWrapper__DHKqL'>
                                  <div>{data[currentLang]?.ratingsCount || 0}</div>
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    enableBackground='new 0 0 24 24'
                                    height='24px'
                                    viewBox='0 0 24 24'
                                    width='12px'
                                    fill='rgb(232,234,237)'
                                  >
                                    <g>
                                      <path d='M0 0h24v24H0V0z' fill='none'></path>
                                      <path d='M0 0h24v24H0V0z' fill='none'></path>
                                    </g>
                                    <g>
                                      <path d='M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z'></path>
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className='BodyHedaer_downloads__ratingWrapper__statDesc__SylNC'>
                              <span style={{textTransform: 'uppercase'}}>
                                {`${numeral(data[currentLang]?.reviews).format('0a')}`}{' '}
                                <span style={{textTransform: 'lowercase'}}>
                                  {data[currentLang]?.inscriptions?.reviews}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div className='BodyHedaer_downloads__ratingWrapper__stat__tqZWn'>
                            <div className='BodyHedaer_downloads__ratingWrapper__statTitle__Hh11i downloads'>
                              {numeral(data[currentLang]?.inscriptions?.countDownloads).format(
                                '0a'
                              )}
                              +
                            </div>
                            <div
                              className='BodyHedaer_downloads__ratingWrapper__statDesc__SylNC'
                              id='headerDownloads'
                            >
                              {data[currentLang]?.inscriptions?.downloads}
                            </div>
                          </div>
                          <div className='BodyHedaer_downloads__ratingWrapper__stat__tqZWn'>
                            <div className='BodyHedaer_downloads__ratingWrapper__statTitle__Hh11i'>
                              <img src={teen} style={{width: '14px', height: '14px'}} />
                            </div>
                            <div className='BodyHedaer_downloads__ratingWrapper__statDesc__SylNC'>
                              <div>
                                <div id='headerTeen'>Teen</div>
                              </div>
                              <div>
                                <img src={info} style={{width: '12px', height: '12px'}} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='BodyHedaer_actions__KxeJ3'>
                    <div className='BodyHedaer_actions__installWrapper__UxUwV'>
                      <button
                        className='BodyHedaer_actions__installWrapper__install__LvZ'
                        id='install_button'
                        style={{display: 'block'}}
                      >
                        {data[currentLang]?.buttons?.install}
                      </button>
                    </div>
                    <div className='BodyHedaer_actions__shareWrapper__YAIYv'>
                      <button className='BodyHedaer_actions__shareWrapper__share__jYQI4'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          height='24'
                          viewBox='0 -960 960 960'
                          width='24'
                        >
                          <path d='M720-80q-50 0-85-35t-35-85q0-7 1-14.5t3-13.5L322-392q-17 15-38 23.5t-44 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q23 0 44 8.5t38 23.5l282-164q-2-6-3-13.5t-1-14.5q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-23 0-44-8.5T638-672L356-508q2 6 3 13.5t1 14.5q0 7-1 14.5t-3 13.5l282 164q17-15 38-23.5t44-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Z'></path>
                        </svg>
                        <div id='headerShare'>{data[currentLang]?.inscriptions?.share}</div>
                      </button>
                      <button className='BodyHedaer_actions__shareWrapper__share2__cchaT'>
                        <svg className='aThNrd' width='24' height='24' viewBox='0 0 24 24'>
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z'
                          ></path>
                        </svg>
                        <div id='headerWishlist'>{data[currentLang]?.inscriptions?.addList}</div>
                      </button>
                    </div>
                    <div className='BodyHedaer_actions__trailerWrapper__IKADz'>
                      <button className='BodyHedaer_trailer__QraXM BodyHedaer_trailer__QraXM_Desktop'>
                        <img src='/public/images/other/play_arrow.svg' />
                        <div id='btnTrailer2'>{data[currentLang]?.buttons?.trailer}</div>
                      </button>
                    </div>
                  </div>
                </div>
              </section>
              <section className='Body_container__tPnbK'>
                <div className='contentContainer Body_contentContainer__p1EzT'>
                  <section className='Body_gameDescription__Vjks'>
                    <div className='Gallery_gallery__W86p0'>
                      <button
                        className='Gallery_buttonPrev__GjkHI'
                        id='Gallery_buttonPrev__GjkHI_Desktop'
                      >
                        <img src={chevron_left} style={{width: '32px', height: '36px'}} />
                      </button>

                      <div className='Gallery_galleryContainer__-p-ic' id='gallery'>
                        {!!data[currentLang]?.slides?.length && (
                          <>
                            {data[currentLang]?.slides?.map((item) => {
                              return (
                                <div
                                  style={{
                                    minWidth: '166px',
                                    backgroundImage: `url(https://api.raulnk.com/${id}/images/slides/${currentLang}/${item})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover',
                                  }}
                                  className='Gallery_galleryContainer__image__QTM3U image'
                                />
                              );
                            })}
                          </>
                        )}
                        {!data[currentLang]?.slides?.length && (
                          <>
                            <div
                              style={{
                                minWidth: '166px',
                                backgroundImage: `url(${imagePlug})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'contain',
                              }}
                              className='Gallery_galleryContainer__image__QTM3U image'
                            />
                            <div
                              style={{
                                minWidth: '166px',
                                backgroundImage: `url(${imagePlug})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'contain',
                              }}
                              className='Gallery_galleryContainer__image__QTM3U image'
                            />
                          </>
                        )}
                      </div>

                      <button
                        className='Gallery_buttonNext__NwwV'
                        id='Gallery_buttonNext__NwwV_Desktop'
                      >
                        <img src={chevron_right} style={{width: '32px', height: '36px'}} />
                      </button>
                    </div>
                    <div className='Body_aboutGame__7mRJx'>
                      <div className='blockHeader'>
                        <h2 id='similarGamesTitle'>
                          {data[currentLang]?.titles?.aboutThisApp || 'About this app'}
                        </h2>
                        <button>
                          <img src={arrow_forward} />
                        </button>
                      </div>
                      <div className='Body_aboutGame__info__wiZBd'>
                        <div
                          className='Body_aboutGame__text__BxpyS'
                          data-g-id='description'
                          dangerouslySetInnerHTML={{__html: data[currentLang]?.description?.replace(/\n/g, "<br>")}}
                        >
                        
                        </div>
                      </div>
                    </div>
                    <div className='Body_dataSafety__nqTSm'>
                      <div className='blockHeader'>
                        <h2 id='dataSafetyTitle'>
                          {data[currentLang]?.titles?.dataSafety || 'Data safety'}
                        </h2>
                        <button>
                          <img src={arrow_forward} />
                        </button>
                      </div>
                      <div className='Body_dataSafety__content__8BMRk'>
                        <div id='dataSafetyText'>
                          {data[currentLang]?.texts?.dataSafety ||
                            'Lorem ipsum dolor sit amet consectetur adipisicing elit. '}
                        </div>
                        <div className='Body_dataSafety__list__O13yT'>
                          <div className='Body_dataSafety__item__GSB6f'>
                            <img src={share} className='T75of whEyae' />
                            <div>
                              <div id='dataSafetyItem1'>
                                {data[currentLang]?.inscriptions?.dataSafety_title_1 ||
                                  'Lorem ipsum dolor '}
                              </div>
                              <div className='Body_dataSafety__item__subTitle__NvB8a'>
                                {data[currentLang]?.inscriptions?.dataSafety_text_1 ||
                                  'Lorem ipsum dolor '}
                              </div>
                            </div>
                          </div>
                          <div className='Body_dataSafety__item__GSB6f'>
                            <img src={cloud} className='T75of whEyae' />
                            <div>
                              <div id='dataSafetyItem2'>
                                {data[currentLang]?.inscriptions?.dataSafety_title_2 ||
                                  'Lorem ipsum dolor '}
                              </div>
                              <div
                                className='Body_dataSafety__item__subTitle__NvB8a'
                                id='dataSafetyItem2Sub'
                              >
                                {data[currentLang]?.inscriptions?.dataSafety_text_2 ||
                                  'Lorem ipsum dolor '}
                              </div>
                            </div>
                          </div>
                          <div className='Body_dataSafety__item__GSB6f'>
                            <img src={close} className='T75of whEyae' />
                            <div id='dataSafetyItem3'>
                              {data[currentLang]?.inscriptions?.dataSafety_title_3 ||
                                'Lorem ipsum dolor '}
                            </div>
                          </div>
                          <div className='Body_dataSafety__item__GSB6f'>
                            <img src={bask} className='T75of whEyae' />
                            <div id='dataSafetyItem4'>
                              {data[currentLang]?.inscriptions?.dataSafety_title_4 ||
                                'Lorem ipsum dolor '}
                            </div>
                          </div>
                          <div className='Body_dataSafety__detailsContainer__yYQp1'>
                            <div id='seeDetails'>
                              {data[currentLang]?.inscriptions?.seeDetails || 'See details'}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='Body_ratings__Sek9'>
                      <div className='blockHeader'>
                        <h2 id='ratingsAndReviewsTitle'>
                          {' '}
                          {data[currentLang]?.titles?.ratings || 'Rating & Reviews'}
                        </h2>
                        <button className='allReviewsArrow'>
                          <img src={arrow_forward} />
                        </button>
                        <div className='Body_ratings__header__verified__HWBGL'>
                          <div className='Body_ratings__header__verifiedWrapper__2h-M7'>
                            <div
                              className='VfPpkd-dgl2Hf-ppHlrf-sM5MNb'
                              data-is-touch-wrapper='true'
                            >
                              <button className='Body_ratings__header__verifiedWrapper__button__DJhmB'>
                                <div jsname='V67aGc' className='VfPpkd-vQzf8d'>
                                  Ratings and reviews are verified
                                </div>
                                <img src={info} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='Body_ratings__buttonsWrapper__qlsuY'>
                        <div className='Body_ratings__buttonsWrapper__list__A82Mf'>
                          <button className='buttonFromGroup Body_customBtn__Kyi2b'>
                            <img src={phone} style={{width: '16px', height: '16px'}} />
                            <div id='btnPhone'>
                              {data[currentLang]?.inscriptions?.device || 'Phone'}
                            </div>
                          </button>
                        </div>
                      </div>
                      <div className='Jwxk6d'>
                        <div className='HJV0ef'>
                          <div className='P4w39d'>
                            <div className='Te9Tpc'>
                              <div>
                                <div className='jILTFe'>{data[currentLang]?.ratingsCount}</div>
                                <div role='img' className='I26one'>
                                  <div
                                    className='Stars'
                                    aria-label='Rating of this product is 2.3 out of 5.'
                                    style={{'--rating': data[currentLang]?.ratingsCount}}
                                  ></div>
                                </div>
                                <div className='EHUI5b'>
                                  <span style={{textTransform: 'uppercase'}}>
                                    {`${numeral(data[currentLang]?.reviews).format('0a')}`}{' '}
                                    <span style={{textTransform: 'lowercase'}}>
                                      {data[currentLang]?.inscriptions?.reviews}
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <div>
                                <div
                                  className='JzwBgb'
                                  role='img'
                                  aria-label='13,554 reviews for star rating 5'
                                >
                                  <div aria-hidden='true' className='Qjdn7d'>
                                    5
                                  </div>
                                  <div aria-hidden='true' className='RJfYGf'>
                                    <div
                                      className='RutFAf wcB8se'
                                      title='13,554'
                                      style={{width: `${data[currentLang]?.ratings?.a1}%`}}
                                    ></div>
                                  </div>
                                </div>
                                <div
                                  className='JzwBgb'
                                  role='img'
                                  aria-label='4,445 reviews for star rating 4'
                                >
                                  <div aria-hidden='true' className='Qjdn7d'>
                                    4
                                  </div>
                                  <div aria-hidden='true' className='RJfYGf'>
                                    <div
                                      className='RutFAf wcB8se'
                                      title='4,445'
                                      style={{width: `${data[currentLang]?.ratings?.a2}%`}}
                                    ></div>
                                  </div>
                                </div>
                                <div
                                  className='JzwBgb'
                                  role='img'
                                  aria-label='1,930 reviews for star rating 3'
                                >
                                  <div aria-hidden='true' className='Qjdn7d'>
                                    3
                                  </div>
                                  <div aria-hidden='true' className='RJfYGf'>
                                    <div
                                      className='RutFAf wcB8se'
                                      title='1,930'
                                      style={{width: `${data[currentLang]?.ratings?.a3}%`}}
                                    ></div>
                                  </div>
                                </div>
                                <div
                                  className='JzwBgb'
                                  role='img'
                                  aria-label='710 reviews for star rating 2'
                                >
                                  <div aria-hidden='true' className='Qjdn7d'>
                                    2
                                  </div>
                                  <div aria-hidden='true' className='RJfYGf'>
                                    <div
                                      className='RutFAf wcB8se'
                                      title='710'
                                      style={{width: `${data[currentLang]?.ratings?.a4}%`}}
                                    ></div>
                                  </div>
                                </div>
                                <div
                                  className='JzwBgb'
                                  role='img'
                                  aria-label='1,092 reviews for star rating 1'
                                >
                                  <div aria-hidden='true' className='Qjdn7d'>
                                    1
                                  </div>
                                  <div aria-hidden='true' className='RJfYGf'>
                                    <div
                                      className='RutFAf wcB8se'
                                      title='1,092'
                                      style={{width: `${data[currentLang]?.ratings?.a5}%`}}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {data[currentLang]?.comments?.map((item, index) => {
                          return (
                            <div className='Body_coment__sxRSJ'>
                              <header>
                                <div className='Body_coment__header__So4'>
                                  <div className='Body_coment__userContainer__-huA8'>
                                    <div
                                      style={
                                        !!item.avatar
                                          ? {
                                              width: '40px',
                                              height: '40px',
                                              backgroundImage: `url(https://api.raulnk.com/${id}/images/users/${currentLang}/${item.avatar})`,
                                              backgroundRepeat: 'no-repeat',
                                              backgroundPosition: 'center',
                                              backgroundSize: 'cover',
                                              borderRadius: '30px',
                                            }
                                          : {
                                              width: '40px',
                                              height: '40px',
                                              backgroundImage: `url(${imagePlug})`,
                                              backgroundRepeat: 'no-repeat',
                                              backgroundPosition: 'center',
                                              backgroundSize: 'cover',
                                              borderRadius: '30px',
                                            }
                                      }
                                    ></div>
                                    <div className='Body_coment__userContainer__name__gQ6lO'>
                                      {item.author}
                                    </div>
                                  </div>
                                  <button className='Body_coment__buttonMenu__oqlS3'>
                                    <img src={dots} />
                                  </button>
                                </div>
                              </header>
                              <div className='Body_coment__messageHeader__usv2I'>
                                <div className='Body_coment__messageHeader__stars__niech'>
                                  {item.rating >= 1 && (
                                    <div className='F7XJmb'>
                                      <div className='Z1Dz7b' aria-hidden='true'>
                                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'></path>
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                  {item.rating >= 2 && (
                                    <div className='F7XJmb'>
                                      <div className='Z1Dz7b' aria-hidden='true'>
                                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'></path>
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                  {item.rating >= 3 && (
                                    <div className='F7XJmb'>
                                      <div className='Z1Dz7b' aria-hidden='true'>
                                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'></path>
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                  {item.rating >= 4 && (
                                    <div className='F7XJmb'>
                                      <div className='Z1Dz7b' aria-hidden='true'>
                                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'></path>
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                  {item.rating === 5 && (
                                    <div className='F7XJmb'>
                                      <div className='Z1Dz7b' aria-hidden='true'>
                                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M0 0h24v24H0z' fill='none'></path>
                                          <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'></path>
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className='Body_coment__messageHeader__date__9SOHe'>
                                  {moment(new Date().setHours(0, 0, 0, 0)).format('MMMM DD, YYYY')}
                                </div>
                              </div>
                              <div className='Body_coment__message__iSdr2'>{item.comment}</div>
                              <div className='Body_coment__countPeople__b-hJQ'></div>
                              <footer className='Body_coment__helpPeople__EB5nU'>
                                <div className='Body_coment__helpPeople__label__fiWbs'>
                                  {data[currentLang]?.inscriptions?.helpFull}
                                </div>
                                <div className='Body_coment__helpPeople__buttons__TSz6'>
                                  <button
                                    className='buttonFromGroup'
                                    style={{fontSize: '14px', height: '22px'}}
                                  >
                                    {data[currentLang]?.inscriptions?.yes}
                                  </button>
                                  <button
                                    className='buttonFromGroup'
                                    style={{fontSize: '14px', height: '22px'}}
                                  >
                                    {data[currentLang]?.inscriptions?.no}
                                  </button>
                                </div>
                              </footer>
                              <div className='Body_coment__response__MBKr3'>
                                <div className='Body_coment__response__header__LaWgO'>
                                  <div className='Body_coment__response__name__THo60'>
                                    {data[currentLang]?.developer}
                                  </div>
                                  <div className='Body_coment__response__date__Fqm8Y'>
                                    {moment(new Date().setHours(0, 0, 0, 0)).format(
                                      'MMMM DD, YYYY'
                                    )}
                                  </div>
                                </div>
                                <div className='Body_coment__response__message__c49Sj'>
                                  {item?.response}
                                </div>
                              </div>
                            </div>
                          );
                        })}

                        <div
                          className='Body_dataSafety__detailsContainer__yYQp1 allReviews'
                          style={{margin: '0px', width: 'fit-content'}}
                        >
                          <div id='seeAllReviews'>
                            {data[currentLang]?.inscriptions?.seeAllReviews}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </section>
              <div className='Layout_mobileMenu__G8ipr'>
                <nav className='Layout_mobileMenu__nav__TD3Lc'>
                  <div className='Layout_mobileMenu__item__4RCSH'>
                    <div className='Layout_mobileMenu__svgContainer__ReFxu'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 21 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className=''
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M19.3 8.4C19.2169 7.65213 19.0648 6.90427 18.9009 6.09902C18.8676 5.93522 18.8338 5.76904 18.8 5.6L18.8 5.59986C18.7 5.1 18.7 5.09996 18.6 4.7L18.5 4.4C18.2 1.8 16 0 13.3 0H6.7C4.1 0 1.8 1.8 1.4 4.4C1.4 4.43174 1.4 4.4534 1.3968 4.47458C1.38993 4.52014 1.36826 4.56347 1.3 4.7C1.3 5.1 1.3 5.1 1.2 5.6C1.1 6.05 1.025 6.525 0.95 7C0.875 7.475 0.8 7.95 0.7 8.4C0.1 11.9 0 12.5 0 12.7C0 14.2 1.2 15.5 2.8 15.5C3.6 15.5 4.3 15.2 4.8 14.7L7.7 11.9H12.4L15.3 14.8C15.8 15.3 16.5 15.6 17.3 15.6C18.8 15.6 20.1 14.4 20.1 12.8C20.0055 12.5165 19.911 11.9651 19.3946 8.95177L19.3 8.4ZM13 5C13.4971 5 13.9 4.59706 13.9 4.1C13.9 3.60294 13.4971 3.2 13 3.2C12.5029 3.2 12.1 3.60294 12.1 4.1C12.1 4.59706 12.5029 5 13 5ZM15.8 6C15.8 6.49706 15.3971 6.9 14.9 6.9C14.4029 6.9 14 6.49706 14 6C14 5.50294 14.4029 5.1 14.9 5.1C15.3971 5.1 15.8 5.50294 15.8 6ZM10.5 5.4C10.2 5.7 10.2 6.3 10.5 6.6C10.8 6.9 11.4 6.9 11.7 6.6C12 6.3 12 5.7 11.7 5.4C11.4 5.1 10.9 5.1 10.5 5.4ZM13 8.8C13.4971 8.8 13.9 8.39706 13.9 7.9C13.9 7.40294 13.4971 7 13 7C12.5029 7 12.1 7.40294 12.1 7.9C12.1 8.39706 12.5029 8.8 13 8.8ZM6.4 3.5H7.6V5.4H9.5V6.6H7.6V8.5H6.4V6.6H4.5V5.4H6.4V3.5ZM16.5 13.3C16.7 13.5 16.9 13.6 17.2 13.6C17.8 13.6 18.2 13.2 18.2 12.6C18.2 12.7 16.8 4.8 16.8 4.7C16.5 3 15 1.8 13.3 1.8H6.7C4.9 1.8 3.5 3 3.2 4.7C3.2 4.8 1.8 12.7 1.8 12.7C1.8 13.3 2.3 13.7 2.8 13.7C3.1 13.7 3.3 13.6 3.5 13.4L6.9 10H13.1L13.4 10.2L16.5 13.3Z'
                        ></path>
                      </svg>
                    </div>
                    <div className='Layout_mobileMenu__title__tzV1h'>Games</div>
                  </div>
                  <div className='Layout_mobileMenu__item__4RCSH'>
                    <div className='Layout_mobileMenu__svgContainer__ReFxu'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='Layout__active__pkDw'
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M15 4H18C19.1 4 20 4.9 20 6V9C20 10.1 19.1 11 18 11H15C13.9 11 13 10.1 13 9V6C13 4.9 13.9 4 15 4ZM9 13H6C4.9 13 4 13.9 4 15V18C4 19.1 4.9 20 6 20H9C10.1 20 11 19.1 11 18V15C11 13.9 10.1 13 9 13ZM18 13H15C13.9 13 13 13.9 13 15V18C13 19.1 13.9 20 15 20H18C19.1 20 20 19.1 20 18V15C20 13.9 19.1 13 18 13ZM9 4H6C4.9 4 4 4.9 4 6V9C4 10.1 4.9 11 6 11H9C10.1 11 11 10.1 11 9V6C11 4.9 10.1 4 9 4Z'
                        ></path>
                      </svg>
                    </div>
                    <div className='Layout_mobileMenu__title__tzV1h Layout__active__pkDw'>Apps</div>
                  </div>
                  <div className='Layout_mobileMenu__item__4RCSH'>
                    <div className='Layout_mobileMenu__svgContainer__ReFxu'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className=''
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M3 2V22H21V2H3ZM5 20H19V4H5V20ZM9 7H6V5H9V7ZM18 7H15V5H18V7ZM6 19H9V17H6V19ZM18 19H15V17H18V19ZM15 15H18V13H15V15ZM9 15H6V13H9V15ZM15 11H18V9H15V11ZM9 11H6V9H9V11Z'
                        ></path>
                      </svg>
                    </div>
                    <div className='Layout_mobileMenu__title__tzV1h'>Movies &amp; TV</div>
                  </div>
                  <div className='Layout_mobileMenu__item__4RCSH'>
                    <div className='Layout_mobileMenu__svgContainer__ReFxu'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className=''
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M12.4996 6.36584L14.001 7.65237V4H11.001V7.65075L12.4996 6.36584ZM10 2H11.001H14.001H15H16.998C18.6461 2 20.001 3.35397 20.001 5.002V18.998C20.001 20.646 18.6461 22 16.998 22H4V2H10ZM18.001 5.002C18.001 4.459 17.542 4 16.998 4H16.001V12L12.5 9L9.001 12V4H6V20H16.998C17.542 20 18.001 19.541 18.001 18.998V5.002Z'
                        ></path>
                      </svg>
                    </div>
                    <div className='Layout_mobileMenu__title__tzV1h'>Books</div>
                  </div>
                  <div className='Layout_mobileMenu__item__4RCSH'>
                    <div className='Layout_mobileMenu__svgContainer__ReFxu'>
                      <svg
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className=''
                      >
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M11.9995 20.439C13.1543 20.787 17.2264 22 17.6293 22C18.4311 22 18.928 21.578 19.154 21.325C19.7049 20.7081 19.7029 20.0604 19.6999 19.0794L19.6999 19.074C19.6989 18.647 19.6299 16.111 19.6009 15.125C20.2258 14.252 21.8914 11.907 22.1604 11.5C22.7292 10.643 23.2201 9.901 22.8972 8.908C22.5724 7.90856 21.7594 7.61034 20.8112 7.26259L20.8096 7.262C20.3747 7.103 17.7853 6.254 16.8195 5.942C16.2026 5.107 14.518 2.848 14.221 2.476L14.2198 2.47445C13.5875 1.68311 13.0416 1 11.9995 1C10.9577 1 10.4108 1.684 9.77797 2.477C9.48103 2.848 7.79639 5.107 7.18052 5.942C6.21372 6.255 3.62427 7.103 3.18436 7.265C2.24156 7.61 1.42773 7.908 1.1028 8.908C0.779871 9.901 1.27077 10.643 1.83965 11.501C2.10059 11.894 3.77424 14.252 4.39911 15.125C4.37011 16.111 4.30113 18.646 4.29913 19.074V19.0741C4.29613 20.058 4.29415 20.708 4.84501 21.324C5.06996 21.576 5.56686 22 6.37069 22C6.7726 22 10.8447 20.787 11.9995 20.439ZM17.6018 15.1838C17.6437 16.6103 17.6991 18.7493 17.6999 19.0787C17.7021 19.8051 17.6963 19.9322 17.6736 19.9767C17.5616 19.9504 17.418 19.9144 17.2472 19.8699C16.8391 19.7634 16.2949 19.6126 15.6462 19.4271C14.6587 19.1447 13.4965 18.8013 12.5766 18.5241L11.9995 18.3502L11.4224 18.5241C10.5029 18.8012 9.34041 19.1447 8.35292 19.4271C7.7042 19.6126 7.16005 19.7634 6.75206 19.8699C6.58148 19.9145 6.43802 19.9504 6.32604 19.9766C6.30304 19.9326 6.2969 19.8071 6.29912 19.0801C6.30067 18.7488 6.35718 16.5803 6.39824 15.1838L6.41807 14.5095L6.02543 13.9609C5.19866 12.8058 3.70925 10.7011 3.50581 10.3947C3.01485 9.65422 2.98744 9.57977 3.00475 9.52653C3.02422 9.46662 3.06796 9.4373 3.87165 9.1432C4.20463 9.02058 6.39401 8.29883 7.79654 7.84477L8.40835 7.64669L8.79007 7.12916C9.57143 6.06978 11.1071 4.01707 11.3394 3.72674C11.8852 3.04281 11.9401 3 11.9995 3C12.049 3 12.0824 3.02198 12.403 3.40831C12.4693 3.48831 12.5251 3.55748 12.6586 3.72451C12.8889 4.01303 14.4014 6.03473 15.2108 7.1304L15.5929 7.64752L16.2047 7.84516C17.4867 8.25931 19.7877 9.01784 20.1229 9.1404L20.1237 9.1407C20.2142 9.17389 20.2145 9.17398 20.3015 9.20614C20.9377 9.44213 20.977 9.47051 20.9951 9.52605C21.0125 9.57968 20.9851 9.65415 20.4941 10.3939C20.2859 10.7088 18.8457 12.7438 17.9746 13.9609L17.5819 14.5095L17.6018 15.1838Z'
                        ></path>
                      </svg>
                    </div>
                    <div className='Layout_mobileMenu__title__tzV1h'>Kids</div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <style type='text/css'>{`
            @font-face {
	font-family: "GSItalicMedium";
	src: url("./fonts/GoogleSans-MediumItalic.eot");
	src: local("Google Sans Medium Italic"), local("GoogleSans-MediumItalic"),
		url("./fonts/GoogleSans-MediumItalic.eot") format("embedded-opentype"),
		url("./fonts/GoogleSans-MediumItalic.woff2") format("woff2"),
		url("./fonts/GoogleSans-MediumItalic.woff") format("woff"),
		url("./fonts/GoogleSans-MediumItalic.ttf") format("truetype");
	font-weight: 500;
	font-style: italic;
}
@font-face {
	font-family: "GSBold";
	src: url("./fonts/GoogleSans-Bold.eot");
	src: local("Google Sans Bold"), local("GoogleSans-Bold"),
		url("./fonts/GoogleSans-Bold.eot") format("embedded-opentype"),
		url("./fonts/GoogleSans-Bold.woff2") format("woff2"),
		url("./fonts/GoogleSans-Bold.woff") format("woff"),
		url("./fonts/GoogleSans-Bold.ttf") format("truetype");
	font-weight: bold;
	font-style: normal;
}
@font-face {
	font-family: "GSItalicNormal";
	src: url("./fonts/GoogleSans-Italic.eot");
	src: local("Google Sans Italic"), local("GoogleSans-Italic"),
		url("./fonts/GoogleSans-Italic.eot") format("embedded-opentype"),
		url("./fonts/GoogleSans-Italic.woff2") format("woff2"),
		url("./fonts/GoogleSans-Italic.woff") format("woff"),
		url("./fonts/GoogleSans-Italic.ttf") format("truetype");
	font-weight: normal;
	font-style: italic;
}
@font-face {
	font-family: "GSMedium";
	src: url("./fonts/GoogleSans-Medium.eot");
	src: local("Google Sans Medium"), local("GoogleSans-Medium"),
		url("./fonts/GoogleSans-Medium.eot") format("embedded-opentype"),
		url("./fonts/GoogleSans-Medium.woff2") format("woff2"),
		url("./fonts/GoogleSans-Medium.woff") format("woff"),
		url("./fonts/GoogleSans-Medium.ttf") format("truetype");
	font-weight: 500;
	font-style: normal;
}
@font-face {
	font-family: "GSRegular";
	src: url("./fonts/GoogleSans-Regular.eot");
	src: local("Google Sans Regular"), local("GoogleSans-Regular"),
		url("./fonts/GoogleSans-Regular.eot") format("embedded-opentype"),
		url("./fonts/GoogleSans-Regular.woff2") format("woff2"),
		url("./fonts/GoogleSans-Regular.woff") format("woff"),
		url("./fonts/GoogleSans-Regular.ttf") format("truetype");
	font-weight: normal;
	font-style: normal;
}
@font-face {
	font-family: "GSItalicBold";
	src: url("./fonts/GoogleSans-BoldItalic.eot");
	src: local("Google Sans Bold Italic"), local("GoogleSans-BoldItalic"),
		url("./fonts/GoogleSans-BoldItalic.eot") format("embedded-opentype"),
		url("./fonts/GoogleSans-BoldItalic.woff2") format("woff2"),
		url("./fonts/GoogleSans-BoldItalic.woff") format("woff"),
		url("./fonts/GoogleSans-BoldItalic.ttf") format("truetype");
	font-weight: bold;
	font-style: italic;
}
@font-face {
	font-family: "Benzin-Medium";
	src: url("./fonts/Benzin-Medium.ttf") format("truetype");
	font-display: swap;
	font-weight: 400;
}
@font-face {
	font-family: "Benzin-Bold";
	src: url("./fonts/Benzin-Bold.ttf") format("truetype");
	font-display: swap;
	font-weight: bold;
}

:root {
	--star-size: 14px;
	--star-color: rgb(241, 243, 244);
	--star-background: #01875f;
}

html,
.body {
	padding: 0;
	margin: 0;
	font-family: Roboto, Arial, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: var(--text-color);
}

.body {
	/*
	overflow-x: hidden;
	overflow-y: scroll;
  */
	visibility: auto;
}

a {
	color: inherit;
	text-decoration: none;
}

* {
	box-sizing: border-box;
}

/*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
	box-sizing: border-box;
}
/*
  2. Remove default margin
*/
* {
	margin: 0;
}
/*
  3. Allow percentage-based heights in the application
*/
html,
.body {
	height: 100%;
}
/*
  Typographic tweaks!
  4. Add accessible line-height
  5. Improve text rendering
*/
.body {
	-webkit-font-smoothing: antialiased;
}
/*
  6. Improve media defaults
*/
img,
picture,
video,
canvas,
svg,
pre {
	display: block;
	max-width: 100%;
}
/*
  7. Remove built-in form typography styles
*/
input,
button,
textarea,
select {
	font: inherit;
}
/*
  8. Avoid text overflows
*/
p,
h1,
h2,
h3,
h4,
h5,
h6 {
	overflow-wrap: break-word;
	font-weight: normal;
}
/*
  9. Create a root stacking context
*/
#root,
#__next {
	isolation: isolate;
}

.contentContainer {
	max-width: 1296px;
	width: 100%;
	margin: 0 auto;
	min-height: 56px;
	position: relative;
	width: calc(100% - 48px);
}

@container screen and (min-width: 600px) {
	.contentContainer {
		width: calc(100% - 96px);
	}
}

.blockHeader {
	position: relative;
	display: flex;
	align-items: center;
	color: rgb(32, 33, 36);
	padding-bottom: 20px;
}
.blockHeader h2 {
	margin-right: 16px;
	font-family: "GSMedium", sans-serif;
	font-size: 22px;
}
.blockHeader > button {
	margin: -11px;
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	border: none;
	border-radius: 50%;
	outline: none;
	font-family: "GSMedium", sans-serif;
	font-size: 100%;
	cursor: pointer;
}
.blockHeader > button:hover {
	background-color: rgb(242, 242, 242);
}
.blockHeader > button div {
	color: rgb(95, 99, 104);
	font-size: 24px;
}

.buttonFromGroup {
	min-height: auto;
	padding: 0 15px 0 15px;
	height: 32px;
	margin-top: 0;
	margin-bottom: 0;
	outline: none;
	border-style: solid;
	border-radius: 16px;
	border-width: 1px;
	border-color: rgb(218, 220, 224);
	color: rgb(95, 99, 104);
	background-color: transparent;
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	font-size: 0.875rem;
	letter-spacing: 0.0107142857em;
	font-weight: 500;
	text-transform: none;
	transition: border 0.28s cubic-bezier(0.4, 0, 0.2, 1),
		box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
	box-shadow: none;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.buttonFromGroup:hover {
	background-color: rgb(242, 242, 242);
	color: #333;
}
.buttonFromGroup > div {
	margin: 0 4px 0 0;
	font-size: 16px;
	width: 16px;
	height: 16px;
}
.buttonFromGroup > div {
	display: inline-block;
	margin: 6px 4px;
	font-size: 14px;
	font-family: "GSMedium", Roboto, Arial, sans-serif;
}
.buttonFromGroup._custom {
	background-color: #e6f3ef;
	color: #056449;
	border: none !important;
}

.Stars {
	--percent: calc(var(--rating) / 5 * 100%);
	display: inline-block;
	font-size: 14px;
	font-family: "GSMedium";
	line-height: 1;
	height: 21px;
}
.Stars::before {
	content: "★★★★★";
	letter-spacing: 3px;
	background: linear-gradient(
		90deg,
		#01875f var(--percent),
		rgb(241, 243, 244) var(--percent)
	);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

.loader {
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100vh;
	background-color: #fff;
	z-index: 10000;
}
.loader .loaderComponent {
	width: 55px;
	height: 55px;
	border: 5px solid #00a173;
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}
@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.uiContainer {
background-color: #ffffff !important;
container-type: inline-size;
}

.Layout_uiContainer__s-EKy {
	position: relative;
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	background-color: #eee;
}

.Layout_header__-fzjb {
	position: sticky;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 64px;
	display: flex;
	align-items: center;
	background-color: #eee;
	z-index: 1;
}
@container (max-width: 840px) {
	.Layout_header__-fzjb {
		height: 56px;
	}
}
.Layout_header__-fzjb .Layout_logo__WLWHd {
	width: -moz-fit-content;
	width: fit-content;
	display: flex;
	align-items: center;
	color: rgb(95, 99, 104);
	margin: 0 14px 0 28px;
}
@container (max-width: 840px) {
	.Layout_header__-fzjb .Layout_logo__WLWHd {
		margin: 0 16px;
	}
}
.Layout_header__-fzjb .Layout_logo__WLWHd svg {
	margin-right: 8px;
	height: 40px;
	width: 40px;
}
.Layout_header__-fzjb .Layout_logo__title__qQBs1 {
	white-space: nowrap;
	font-family: GSMedium, sans-serif;
	font-size: 1.375rem;
}
.Layout_header__-fzjb .Layout_navBar__Wo-Ue {
	position: relative;
	width: -moz-fit-content;
	width: fit-content;
}
@container (max-width: 840px) {
	.Layout_header__-fzjb .Layout_navBar__Wo-Ue {
		display: none;
	}
}
.Layout_header__-fzjb .Layout_navBar__list__a5aCz {
	list-style: none;
	display: flex;
	padding: 0;
	align-items: center;
}
.Layout_header__-fzjb .Layout_navBar__item__3f3Xc {
	color: rgb(95, 99, 104);
	font-family: GSMedium, sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	padding-right: 16px;
	padding-left: 16px;
	cursor: pointer;
	transition: 0.3s linear;
}
.Layout_header__-fzjb .Layout_navBar__item__3f3Xc:hover {
	color: black;
}
.Layout_header__-fzjb .Layout_navBar__item__3f3Xc.Layout__active__pkDw {
	color: #01875f;
}
.Layout_header__-fzjb .Layout_navBar__Wo-Ue .Layout_pointer__2IrZF {
	position: absolute;
	width: 0;
	left: 0;
	top: 38px;
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
	border-top-width: 3px;
	border-color: #01875f;
	border-top-style: solid;
	transition: 0.25s transform cubic-bezier(0.4, 0, 0.2, 1);
}
.Layout_header__-fzjb .Layout_actions__vGVVH {
	align-items: center;
	display: flex;
	margin: 0 10px 0 auto;
}
.Layout_header__-fzjb .Layout_actions__vGVVH .Layout_search__i-X4s {
	width: 48px;
	height: 48px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: none;
	border-radius: 50%;
	background-color: transparent;
	color: rgb(95, 99, 104);
	cursor: pointer;
	transition: 0.25s transform cubic-bezier(0.4, 0, 0.2, 1);
}
.Layout_header__-fzjb .Layout_actions__vGVVH .Layout_search__i-X4s:hover {
	background-color: rgb(242, 242, 242);
}
.Layout_header__-fzjb .Layout_actions__vGVVH .Layout_search__i-X4s > div {
	width: 24px;
	height: 24px;
}
.Layout_header__-fzjb .Layout_actions__vGVVH .Layout_search__i-X4s .Layout_img__J7ivY {
	min-width: 32px;
	height: 32px;
	border-radius: 50%;
	background-color: black;
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
}

.Layout_footer__3QoUo {
	margin-left: 24px;
	margin-right: 24px;
	padding-bottom: 72px;
	margin: 0 auto;
}
@container screen and (min-width: 840px) {
	.Layout_footer__3QoUo {
		padding-bottom: 16px;
	}
}
.Layout_footer__line__0ei7u {
	border-color: rgb(232, 234, 237);
	border-bottom: 1px solid;
	margin-bottom: 36px;
	padding-top: 36px;
	width: 100%;
}
.Layout_footer__line__0ei7u:not(:disabled) {
	border-color: rgb(232, 234, 237);
}
.Layout_footer__body__vZkcV {
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 24px;
}
@container screen and (min-width: 840px) {
	.Layout_footer__body__vZkcV {
		column-gap: 16px;
		grid-template-columns: 244px auto;
	}
}
.Layout_footer__body__head__WRv3 {
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
	font-family: "GSMedium", Helvetica, Arial, sans-serif;
	line-height: 32px;
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
}
.Layout_footer__body__head__WRv3:not(:disabled) {
	color: rgb(95, 99, 104);
}
.Layout_footer__body__other__q-XLN {
	font-size: 0.875rem;
	letter-spacing: 0.0142857143em;
	font-weight: 400;
	width: max-content;
	line-height: 32px;
	font-family: "GSRegular", Helvetica, Arial, sans-serif;
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
}
.Layout_footer__body__other__q-XLN:not(:disabled) {
	color: rgb(95, 99, 104);
}
.Layout_footer__footer__VswCM {
	margin-top: 32px;
	display: flex;
	flex-wrap: wrap;
}
.Layout_footer__footer__link__9KWw4 {
	font-family: "Google Sans", Helvetica, Arial, sans-serif;
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.75rem;
	line-height: 48px;
	margin-right: 24px;
}
.Layout_footer__footer__link__9KWw4:not(:disabled) {
	color: rgb(95, 99, 104);
}
.Layout_footer__footer__countryWrapper__Co0Gr {
	font-family: "Google Sans", Helvetica, Arial, sans-serif;
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.75rem;
	line-height: 48px;
	margin-right: 24px;
}
.Layout_footer__footer__countryWrapper__Co0Gr:not(:disabled) {
	color: rgb(95, 99, 104);
}
.Layout_footer__footer__country__kgHzB {
	display: grid;
	grid-template-columns: repeat(2, max-content);
	grid-template-rows: 1fr;
	column-gap: 12px;
}
.Layout_footer__footer__country__kgHzB img {
	align-self: center;
	width: 24px;
	height: 18px;
}

.Body_container__tPnbK {
	position: relative;
	margin: 40px auto 0px;
	width: 100%;
	min-height: 600px;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding-bottom: 32px;
	background-color: transparent;
	z-index: 0;
}

@container screen and (min-width: 960px) {
	.Body_contentContainer__p1EzT {
		display: flex;
		justify-content: space-between;
	}
}

@container screen and (min-width: 960px) {
	.Body_gameDescription__Vjks {
		width: calc(100% - 348px);
	}
}
@container screen and (min-width: 1280px) {
	.Body_gameDescription__Vjks {
		width: calc(100% - 436px);
	}
}

.Body_aboutGame__7mRJx {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
@container screen and (min-width: 600px) {
	.Body_aboutGame__7mRJx {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_aboutGame__7mRJx {
		margin-bottom: 24px;
	}
}
.Body_aboutGame__info__wiZBd {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	font-family: Roboto, Helvetica, Arial, sans-serif;
}
.Body_aboutGame__text__BxpyS {
	font-family: Roboto, Helvetica, Arial, sans-serif;
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 6;
	line-clamp: 6;
	max-height: 7.5rem;
	overflow: hidden;
	text-overflow: ellipsis;
}
.Body_aboutGame__update__VWpVC {
	display: grid;
	grid-gap: 16px;
	grid-template-columns: repeat(2, 1fr);
	margin-top: 24px;
}
.Body_aboutGame__update__title__c1Zet {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
}
.Body_aboutGame__update__date__i1zdA {
	font-family: Roboto, Helvetica, Arial, sans-serif;
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	margin-top: 4px;
	color: rgb(95, 99, 104);
}
.Body_aboutGame__buttons__0lrvJ {
	display: flex;
	flex-wrap: wrap;
	gap: 16px 12px;
	margin-bottom: 4px;
	margin-top: 28px;
}
@container screen and (min-width: 600px) {
	.Body_aboutGame__buttons__0lrvJ {
		margin-bottom: 0;
	}
}

.Body_dataSafety__nqTSm {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
@container screen and (min-width: 600px) {
	.Body_dataSafety__nqTSm {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_dataSafety__nqTSm {
		margin-bottom: 24px;
	}
}
.Body_dataSafety__content__8BMRk {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	font-family: Roboto, Helvetica, Arial, sans-serif;
}
.Body_dataSafety__list__O13yT {
	border-color: rgb(218, 220, 224);
	border-radius: 8px;
	border: 1px solid;
	margin-top: 30px;
	padding: 20px 20px 0;
}
.Body_dataSafety__list__O13yT:not(:disabled) {
	border-color: rgb(218, 220, 224);
}
.Body_dataSafety__item__GSB6f {
	align-items: flex-start;
	display: flex;
	margin-top: 20px;
}
.Body_dataSafety__item__GSB6f:first-child {
	margin-top: 0px;
}
.Body_dataSafety__item__GSB6f img {
	height: 20px;
	margin-right: 20px;
	width: 20px;
	background-size: contain;
}
.Body_dataSafety__item__subTitle__NvB8a {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-family: Roboto, Arial, sans-serif;
	line-height: 1rem;
	font-size: 0.75rem;
	letter-spacing: 0.025em;
	font-weight: 400;
}
.Body_dataSafety__item__subTitle__NvB8a :not(:disabled) {
	color: rgb(95, 99, 104);
}
.Body_dataSafety__item__subTitle__NvB8a a {
	text-decoration: underline;
}
.Body_dataSafety__detailsContainer__yYQp1 {
	color: #01875f;
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	font-size: 0.875rem;
	letter-spacing: 0.0107142857em;
	font-weight: 500;
	text-transform: none;
	height: 36px;
	border-radius: 4px;
	margin: 10px 0px;
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	min-width: 64px;
	border: none;
	outline: none;
	line-height: inherit;
	-webkit-user-select: none;
	user-select: none;
	-webkit-appearance: none;
	overflow: visible;
	vertical-align: middle;
	background: transparent;
	padding: 0 8px 0 8px;
	cursor: pointer;
}
.Body_dataSafety__detailsContainer__yYQp1:hover {
	background-color: rgb(244, 249, 254);
	color: rgb(14, 82, 57);
}

.Body_ratings__Sek9 {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
@container screen and (min-width: 600px) {
	.Body_ratings__Sek9 {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_ratings__Sek9 {
		margin-bottom: 24px;
	}
}
@container screen and (min-width: 600px) {
	.Body_ratings__header__verified__HWBGL {
		display: block;
		margin-left: auto;
	}
}
.Body_ratings__header__verifiedWrapper__2h-M7 {
	margin-top: -10px;
	display: none;
}
@container screen and (min-width: 600px) {
	.Body_ratings__header__verifiedWrapper__2h-M7 {
		display: inline;
	}
}
.Body_ratings__header__verifiedWrapper__button__DJhmB {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	min-width: 64px;
	border: none;
	outline: none;
	line-height: inherit;
	-webkit-user-select: none;
	user-select: none;
	-webkit-appearance: none;
	overflow: visible;
	vertical-align: middle;
	background: transparent;
	padding: 0 8px 0 8px;
	font-family: "GSRegular", Roboto, Arial, sans-serif;
	font-size: 14px;
	letter-spacing: 0.0107142857em;
	text-transform: none;
	font-weight: 400;
	height: 48px;
	margin-top: 0;
	margin-bottom: 0;
	border-radius: 8px;
	color: rgb(95, 99, 104);
	cursor: pointer;
}
.Body_ratings__header__verifiedWrapper__button__DJhmB:hover {
	background-color: rgb(247, 247, 247);
	color: rgb(20, 21, 24);
}
@container screen and (min-width: 1280px) {
	.Body_ratings__header__verifiedWrapper__button__DJhmB {
		font-size: 0.875rem;
	}
}
.Body_ratings__header__verifiedWrapper__button__DJhmB > div:last-child {
	width: 16px;
	height: 16px;
	font-size: 16px;
	margin-left: 8px;
}
.Body_ratings__buttonsWrapper__qlsuY {
	margin-bottom: 12px;
}
.Body_ratings__buttonsWrapper__list__A82Mf {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
}
.Body_ratings__buttonsWrapper__list__A82Mf .Body_customBtn__Kyi2b {
	background-color: #e6f3ef;
	color: #056449;
	border: none !important;
}
.Body_ratings__buttonsWrapper__list__A82Mf button {
	display: flex;
	justify-content: center;
	align-items: center;
}
.Body_ratings__buttonsWrapper__list__A82Mf button div {
	font-size: 16px;
	width: 16px;
	height: 16px;
}
.Body_ratings__buttonsWrapper__list__A82Mf button div,
.Body_ratings__buttonsWrapper__list__A82Mf button svg {
	margin: 0 4px 0 0;
}
.Body_ratings__buttonsWrapper__list__A82Mf button svg {
	fill: #5f6368;
	transform: translateY(-2px);
}
.Body_ratings__buttonsWrapper__list__A82Mf button div {
width: fit-content;
	display: block;
	margin: 6px 4px;
	font-size: 14px;
	font-family: "GSMedium", Roboto, Arial, sans-serif;
}

.Body_coment__sxRSJ {
	padding: 16px 0;
}
@container screen and (min-width: 960px) {
	.Body_coment__sxRSJ {
		padding: 20px 0;
	}
}
@container screen and (min-width: 1280px) {
	.Body_coment__sxRSJ {
		padding: 24px 0;
	}
}
.Body_coment__header__So4 {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.Body_coment__userContainer__-huA8 {
	display: grid;
	align-items: center;
	grid-column-gap: 16px;
	grid-template-columns: repeat(2, max-content);
}
.Body_coment__userContainer__-huA8 img {
	border-radius: 50%;
	width: 32px;
	height: 32px;
	overflow: hidden;
	background-size: cover;
}
.Body_coment__userContainer__name__gQ6lO {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
}
.Body_coment__userContainer__name__gQ6lO:not(:disabled) {
	color: rgb(32, 33, 36);
}
.Body_coment__buttonMenu__oqlS3 {
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	border: none;
	border-radius: 50%;
	outline: none;
	font-family: "GSMedium", sans-serif;
	font-size: 100%;
	cursor: pointer;
}
.Body_coment__buttonMenu__oqlS3:hover {
	background-color: rgb(242, 242, 242);
}
.Body_coment__buttonMenu__oqlS3 div {
	color: rgb(95, 99, 104);
	font-size: 24px;
}
.Body_coment__messageHeader__usv2I {
display: flex;
align-items: center;
	margin-top: 16px;
}
.Body_coment__messageHeader__stars__niech {
	display: inline-block;
}
.Body_coment__messageHeader__stars__niech div {
	display: inline-block;
	text-align: left;
	width: 12px;
	height: 12px;
}
.Body_coment__messageHeader__date__9SOHe {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-family: Roboto, Arial, sans-serif;
	font-size: 0.75rem;
	font-weight: 400;
	letter-spacing: 0.025em;
	line-height: 1rem;
	margin-left: 1ch;
}
.Body_coment__messageHeader__date__9SOHe:not(:disabled) {
	color: rgb(95, 99, 104);
}
.Body_coment__message__iSdr2 {
	margin-top: 8px;
	font-size: 0.875rem;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	overflow-wrap: anywhere;
	color: #5f6368;
}
.Body_coment__countPeople__b-hJQ {
	font-family: Roboto, Arial, sans-serif;
	font-size: 0.75rem;
	font-weight: 400;
	letter-spacing: 0.025em;
	line-height: 1rem;
	color: #5f6368;
	margin-top: 16px;
}
.Body_coment__helpPeople__EB5nU {
	align-items: center;
	display: flex;
	margin-top: 12px;
}
.Body_coment__helpPeople__label__fiWbs {
	font-family: Roboto, Arial, sans-serif;
	font-size: 0.75rem;
	font-weight: 400;
	letter-spacing: 0.025em;
	line-height: 1rem;
	margin-right: 24px;
	color: #5f6368;
}
.Body_coment__helpPeople__buttons__TSz6 {
	display: flex;
	/* flex-wrap: wrap; */
	gap: 12px;
}
.Body_coment__response__MBKr3 {
	background-color: rgb(248, 249, 250);
	display: grid;
	align-items: center;
	margin: 24px 24px 0;
	padding: 12px 16px 16px;
	grid-row-gap: 12px;
	grid-template-columns: 1fr;
}
.Body_coment__response__MBKr3:not(:disabled) {
	background-color: rgb(248, 249, 250);
}
.Body_coment__response__header__LaWgO {
	display: flex;
	align-items: center;
}
.Body_coment__response__name__THo60 {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
}
.Body_coment__response__name__THo60:not(:disabled) {
	color: rgb(32, 33, 36);
}
.Body_coment__response__date__Fqm8Y {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-family: Roboto, Arial, sans-serif;
	line-height: 1rem;
	font-size: 0.75rem;
	letter-spacing: 0.025em;
	font-weight: 400;
	margin-left: auto;
}
.Body_coment__response__date__Fqm8Y::not(:disabled) {
	color: rgb(95, 99, 104);
}
.Body_coment__response__message__c49Sj {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
}
.Body_coment__response__message__c49Sj:not(:disabled) {
	color: rgb(95, 99, 104);
}

.Body_footer__3DkfM {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
@container screen and (min-width: 600px) {
	.Body_footer__3DkfM {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_footer__3DkfM {
		margin-bottom: 24px;
	}
}
.Body_footer__title__4x8v9 {
	padding-bottom: 20px;
}
.Body_footer__title__4x8v9 > h2 {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	line-height: 1.5rem;
	font-size: 1.125rem;
	letter-spacing: 0;
	font-weight: 500;
	display: flex;
	justify-content: space-between;
}
.Body_footer__title__4x8v9 > h2 :not(:disabled) {
	color: rgb(32, 33, 36);
}
@container screen and (min-width: 600px) {
	.Body_footer__title__4x8v9 > h2 {
		justify-content: start;
	}
}
@container screen and (min-width: 1280px) {
	.Body_footer__title__4x8v9 > h2 {
		font-family: "Google Sans", Roboto, Arial, sans-serif;
		line-height: 1.75rem;
		font-size: 1.375rem;
		letter-spacing: 0;
		font-weight: 400;
		font-weight: 500;
	}
}
.Body_footer__text__xc1AF {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	font-family: Roboto, Helvetica, Arial, sans-serif;
}
.Body_footer__text__xc1AF:not(:disabled) {
	color: rgb(95, 99, 104);
}

@container screen and (min-width: 960px) {
	.Body_otherGames__EAjqx {
		min-width: 276px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_otherGames__EAjqx {
		min-width: 364px;
	}
}
.Body_otherGames__EAjqx .Body_support__cCsF7 {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
@container screen and (min-width: 600px) {
	.Body_otherGames__EAjqx .Body_support__cCsF7 {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_otherGames__EAjqx .Body_support__cCsF7 {
		margin-bottom: 24px;
	}
}
.Body_otherGames__EAjqx .Body_support__list__DsWL7 {
	display: none;
	gap: 24px;
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	font-family: Roboto, Helvetica, Arial, sans-serif;
}
.Body_otherGames__EAjqx .Body_support__list__DsWL7.Body__open__xDyIg {
	display: grid;
}
.Body_otherGames__EAjqx .Body_support__item__D3QJO {
	border-radius: 8px;
	display: flex;
	padding: 12px;
	margin: -12px;
	cursor: pointer;
}
.Body_otherGames__EAjqx .Body_support__item__D3QJO:hover {
	background-color: rgb(242, 242, 242);
}
.Body_otherGames__EAjqx .Body_support__item__D3QJO div {
	color: rgb(95, 99, 104);
	font-size: 18px;
	margin-right: 16px;
}
.Body_otherGames__EAjqx .Body_support__item__titleWrapper__5eNfm {
	display: flex;
	flex-direction: column;
}
.Body_otherGames__EAjqx .Body_support__item__title__RZYCu {
	font-family: "GSMedium", sans-serif;
	font-size: 14px;
	color: rgb(32, 33, 36);
}
.Body_otherGames__EAjqx .Body_support__item__subTitle__8I6yT {
	color: rgb(95, 99, 104);
	font-family: Roboto, Helvetica, Arial, sans-serif;
	font-size: 14px;
}
.Body_otherGames__EAjqx .Body_games__WdUS {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
@container screen and (min-width: 600px) {
	.Body_otherGames__EAjqx .Body_games__WdUS {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Body_otherGames__EAjqx .Body_games__WdUS {
		margin-bottom: 24px;
	}
}
.Body_otherGames__EAjqx .Body_games__list__btbmQ {
	display: grid;
	grid-gap: 24px;
	grid-template-columns: repeat(2, 1fr);
}
@container screen and (min-width: 960px) {
	.Body_otherGames__EAjqx .Body_games__list__btbmQ {
		grid-template-columns: repeat(1, 1fr);
	}
}
.Body_otherGames__EAjqx .Body_games__itemWrapper__2aheB {
	border-radius: 8px;
	margin: -12px;
}
.Body_otherGames__EAjqx .Body_games__item__orGLb {
	margin: 12px;
	column-gap: 16px;
	display: grid;
	grid-template-columns: max-content auto;
}
@container screen and (min-width: 1280px) {
	.Body_otherGames__EAjqx .Body_games__item__orGLb {
		margin: 16px 12px;
	}
}
.Body_otherGames__EAjqx .Body_games__item__orGLb img {
	border-radius: 12px;
	border-width: 0;
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
	height: 56px;
	width: 56px;
	background-size: contain;
}
@container screen and (min-width: 1280px) {
	.Body_otherGames__EAjqx .Body_games__item__orGLb img {
		height: 64px;
		width: 64px;
	}
}
.Body_otherGames__EAjqx .Body_games__item__info__Sh8Dv {
	display: grid;
	grid-template-rows: max-content;
	height: -moz-fit-content;
	height: fit-content;
	row-gap: 2px;
}
@container screen and (min-width: 1280px) {
	.Body_otherGames__EAjqx .Body_games__item__info__Sh8Dv {
		row-gap: 0;
	}
}
.Body_otherGames__EAjqx .Body_games__item__textContainer__o7m3d {
	align-items: center;
	display: inline-flex;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 16px;
	color: rgb(32, 33, 36);
}
.Body_otherGames__EAjqx .Body_games__item__subTitle__IeFDW {
	font-size: 14px;
}
.Body_otherGames__EAjqx .Body_games__item__raiting__AqEdw {
	display: flex;
	align-items: center;
	color: rgb(95, 99, 104);
	font-size: 14px;
}

.Body_flagContainer__umuNh {
	container-type: inline-size;
	container-name: section-wrapper;
	padding-top: 20px;
	width: 100%;
}
.Body_flagContainer__umuNh.Body__screenWidth__owpNp {
	display: block;
}
@container screen and (max-width: 960px) {
	.Body_flagContainer__umuNh.Body__screenWidth__owpNp {
		display: none;
	}
}
.Body_flagContainer__umuNh.Body__phoneWidth__3teq7 {
	display: none;
}
@container screen and (max-width: 960px) {
	.Body_flagContainer__umuNh.Body__phoneWidth__3teq7 {
		display: block;
	}
}
@container screen and (min-width: 1280px) {
	.Body_flagContainer__umuNh {
		margin-bottom: 24px;
	}
}
@container screen and (min-width: 600px) {
	.Body_flagContainer__umuNh {
		margin-bottom: 16px;
	}
}
.Body_flagContainer__flag__ZHr0y {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
	font-family: Roboto, Helvetica, Arial, sans-serif;
}
.Body_flagContainer__flag__ZHr0y:not(:disabled) {
	color: rgb(95, 99, 104);
}
.Body_flagContainer__flag__ZHr0y > div {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-family: "Google Sans", Roboto, Arial, sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
	align-items: center;
	display: flex;
}
.Body_flagContainer__flag__ZHr0y > div:not(:disabled) {
	color: rgb(32, 33, 36);
}
.Body_flagContainer__flag__ZHr0y > div > div {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-size: 18px;
	margin-right: 16px;
}
.Body_flagContainer__flag__ZHr0y > div > div:not(:disabled) {
	color: rgb(95, 99, 104);
}

.Gallery_gallery__W86p0 {
	position: relative;
}

.Gallery_buttonPrev__GjkHI,
.Gallery_buttonNext__NwwV {
	position: absolute;
	min-width: 40px;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: 56px;
	height: 56px;
	padding: 0;
	border: none;
	border-radius: 50%;
	background-color: #fff;
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
	color: rgb(95, 99, 104);
	font-size: 24px;
	fill: currentColor;
	text-decoration: none;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	overflow: visible;
	transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 15ms linear 30ms,
		transform 0.27s 0ms cubic-bezier(0, 0, 0.2, 1);
}
.Gallery_buttonPrev__GjkHI:hover,
.Gallery_buttonNext__NwwV:hover {
	background-color: rgb(242, 242, 242);
}
@container (max-width: 600px) {
	.Gallery_buttonPrev__GjkHI,
	.Gallery_buttonNext__NwwV {
		display: none;
	}
}
.Gallery_buttonPrev__GjkHI > div,
.Gallery_buttonNext__NwwV > div {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 30px;
	font-weight: 200;
	width: 36px;
	height: 36px;
}

.Gallery_buttonPrev__GjkHI {
	left: 0;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);
}

.Gallery_buttonNext__NwwV {
	right: 0;
	top: 50%;
	transform: translateX(50%) translateY(-50%);
}

.Gallery_galleryContainer__-p-ic {
	width: 100%;
	display: flex;
	flex-direction: row;
	overflow-x: scroll;
	scroll-snap-type: x mandatory;
	scrollbar-width: none;
}
@container screen and (min-width: 600px) {
	.Gallery_galleryContainer__-p-ic {
		margin-bottom: 16px;
	}
}
@container screen and (min-width: 1280px) {
	.Gallery_galleryContainer__-p-ic {
		margin-bottom: 24px;
	}
}
.Gallery_galleryContainer__image__QTM3U {
	display: block;
	border-width: 0;
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
	border-radius: 8px;
	cursor: pointer;
	height: 260px;
	margin-right: 12px;
	scroll-snap-align: start;
}
.Gallery_galleryContainer__image__QTM3U:last-child {
	margin-right: 0px;
}
@container screen and (min-width: 1280px) {
	.Gallery_galleryContainer__image__QTM3U {
		margin-right: 16px;
		height: 296px;
	}
}

.BodyHedaer_container__4jlbL {
	position: relative;
	// margin-top: 64px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding-bottom: 32px;
	background-color: #202124;
	overflow: hidden;
	z-index: 0;
}
@container (max-width: 840px) {
	.BodyHedaer_container__4jlbL {
		// margin-top: 56px;
	}
}

.BodyHedaer_contentContainer__6We-0 {
	position: relative;
	top: 0px;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__m96AP {
	position: absolute;
	z-index: 0;
}
@container (max-width: 1024px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__m96AP {
		width: calc(100% + 48px);
		left: 50%;
		transform: translateX(-50%);
	}
}
@container screen and (min-width: 1024px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__m96AP {
		height: 468px;
		width: 832px;
		right: -72px;
	}
}
@container screen and (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__m96AP {
		height: 532px;
		width: 947px;
	}
}
@container screen and (min-width: 1440px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__m96AP {
		height: 600px;
		width: 1067px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__trailerWrapper__H4HZM {
	position: absolute;
	bottom: 50%;
	right: 50%;
	transform: translate(50%, 50%);
	z-index: 10;
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__trailerWrapper__H4HZM {
		display: none;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__video__Irpty {
	position: relative;
	top: 0px;
	object-fit: cover;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	height: 240px;
}
@container screen and (min-width: 1024px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__video__Irpty {
		height: 468px;
		width: 832px;
		right: 0px;
	}
}
@container screen and (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__video__Irpty {
		height: 532px;
		width: 947px;
	}
}
@container screen and (min-width: 1440px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__video__Irpty {
		height: 600px;
		width: 1067px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__shadow__kkeFR {
	background: linear-gradient(to top, rgb(32, 33, 36) 0, rgba(0, 0, 0, 0) 56%);
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	position: absolute;
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__shadow__kkeFR {
		background: linear-gradient(to right, rgb(32, 33, 36) 0, rgba(0, 0, 0, 0) 56%),
			linear-gradient(to top, rgb(32, 33, 36) 0, rgba(0, 0, 0, 0) 56%);
	}
}
@container screen and (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__shadow__kkeFR {
		height: 532px;
		width: 947px;
		background: linear-gradient(to right, rgb(32, 33, 36) 0, rgba(0, 0, 0, 0) 56%),
			linear-gradient(to top, rgb(32, 33, 36) 0, rgba(0, 0, 0, 0) 56%),
			linear-gradient(to left, rgb(32, 33, 36) 0, rgba(0, 0, 0, 0) 56%);
	}
}
@container screen and (min-width: 1440px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__shadow__kkeFR {
		height: 600px;
		width: 1067px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_videoContainer__play__j16UD {
	display: none;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__9BTe {
	display: inline-flex;
	flex-direction: column;
	justify-content: flex-end;
	position: relative;
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__9BTe {
		min-height: 240px;
	}
}
@container screen and (min-width: 1024px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__9BTe {
		min-height: 436px;
	}
}
@container screen and (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__9BTe {
		min-height: 500px;
	}
}
@container screen and (min-width: 1440px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__9BTe {
		min-height: 568px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__titles__SXRwG {
	margin-top: calc(240px - 40px);
	align-items: flex-start;
	display: flex;
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__titles__SXRwG {
		margin-top: 112px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__image__7HrCk {
	display: inline-block;
	border-radius: 20%;
	border-width: 0;
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
	border-radius: 4px;
	margin: 7px 24px 0 0;
	width: 72px;
  aspect-ratio: 1/1;
	background-size: contain;
}
@container (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__image__7HrCk {
		width: 96px;
	}
}
@container (min-width: 960px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__image__7HrCk {
		display: none;
	}
}
@container (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__image__7HrCk {
		width: 128px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__description__qIc72 h1 {
	font-family: "GSMedium", sans-serif;
	line-height: 2rem;
	font-size: 1.5rem;
	letter-spacing: 0;
	font-weight: 500;
	align-items: flex-end;
	display: flex;
	overflow-wrap: anywhere;
	width: 100%;
	max-height: 112px;
	word-break: keep-all;
	color: rgb(232, 234, 237);
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__description__qIc72 h1 {
		line-height: 2.75rem;
		font-size: 2.25rem;
		letter-spacing: 0;
	}
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__description__qIc72 h1 {
		width: 560px;
	}
}
@container screen and (min-width: 1024px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__description__qIc72 h1 {
		max-height: 192px;
	}
}
@container screen and (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__description__qIc72 h1 {
		line-height: 4rem;
		font-size: 3.5rem;
		letter-spacing: 0;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__developers__jCfxH {
	margin-top: 2px;
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__developers__jCfxH {
		margin-top: 16px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__developers__name__8UzSw {
	color: #00a173;
	font-family: "GSMedium", sans-serif;
	line-height: 1.5rem;
	font-size: 1rem;
	letter-spacing: 0.00625em;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__developers__contacts__nSITA {
display: flex;
	color: rgb(154, 160, 166);
	line-height: 1rem;
	font-size: 0.75rem;
	letter-spacing: 0.025em;
	font-weight: 400;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__developers__contacts__nSITA
	> div:last-child::before {
	content: " · ";
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__downloadsWrapper__xK1Hm {
	height: 64px;
	margin: 16px 0 24px 0;
	padding: 12px 0;
}
@container screen and (min-width: 1024px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__downloadsWrapper__xK1Hm {
		margin-left: 0;
		width: 100%;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__downloads__Yqvyf {
	align-items: center;
	display: flex;
	overflow: auto;
	width: 100%;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__downloads__image__X5ia {
	display: none;
	border-width: 0;
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
	border-radius: 8px;
	flex-shrink: 0;
	margin-right: 16px;
	width: 48px;
	background-size: contain;
}
@container screen and (min-width: 960px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_descriptionsContainer__downloads__image__X5ia {
		display: inline-block;
	}
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__-LcJP {
	align-items: center;
	display: flex;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__stat__tqZWn {
	padding-left: 0;
	min-width: 96px;
	padding: 0 16px;
	position: relative;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__stat__tqZWn:nth-child(1) {
	padding-left: 0;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__stat__tqZWn:nth-child(2) {
	padding: 0 24px;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__stat__tqZWn:nth-child(2)::before {
	content: "";
	display: block;
	height: 24px;
	left: 0;
	position: absolute;
	top: calc(50% - 12px);
	width: 1px;
	background-color: rgb(60, 64, 67);
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__stat__tqZWn:nth-child(3) {
	padding: 0 24px;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__stat__tqZWn:nth-child(3)::before {
	content: "";
	display: block;
	height: 24px;
	left: 0;
	position: absolute;
	top: calc(50% - 12px);
	width: 1px;
	background-color: rgb(60, 64, 67);
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__statTitle__Hh11i {
	color: rgb(232, 234, 237);
	font-family: "GSMedium", sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	align-items: center;
	display: flex;
	height: 24px;
	justify-content: center;
	white-space: nowrap;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__starWrapper__DHKqL {
	align-items: center;
	display: flex;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_descriptionsContainer__9BTe
	.BodyHedaer_downloads__ratingWrapper__statDesc__SylNC {
	color: rgb(154, 160, 166);
	font-family: Roboto, Arial, sans-serif;
	line-height: 1rem;
	font-size: 0.75rem;
	letter-spacing: 0.025em;
	font-weight: 400;
	align-items: center;
	display: flex;
	height: 20px;
	justify-content: center;
	white-space: nowrap;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__KxeJ3 {
	align-items: unset;
	display: flex;
	flex-direction: column;
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__KxeJ3 {
		align-items: center;
		flex-direction: row;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__installWrapper__UxUwV {
	flex-grow: 1;
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__installWrapper__UxUwV {
		flex-grow: unset;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__installWrapper__install__LvZ {
	width: 100%;
	font-family: "GSMedium", sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
	height: 36px;
	margin: 6px 0;
	min-height: 36px;
	min-width: 160px;
	padding: 8px 16px;
	color: rgb(32, 33, 36);
	background-color: #00a173;
	box-shadow: none;
	border-radius: 8px;
	border: none;
	outline: none;
}

@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__installWrapper__install__LvZ {
		width: unset;
	}
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_actions__installWrapper__install__LvZ.BodyHedaer__verifying__2HEhj {
	background-color: rgb(154, 160, 166);
	color: #42454b;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__installWrapper__install__loader__ce2Yi {
	display: block;
	width: 20px;
	padding: 2px;
	aspect-ratio: 1;
	border-radius: 50%;
	background: #42454b;
	--_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
	mask: var(--_m);
	mask-composite: subtract;
	animation: BodyHedaer_l3__rJHqr 1s infinite linear;
}
@keyframes BodyHedaer_l3__rJHqr {
	to {
		transform: rotate(1turn);
	}
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_actions__installWrapper__UxUwV
	.BodyHedaer_loaderContainer__y3jJh {
	height: 36px;
	min-width: 160px;
	width: 100%;
	display: none;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_actions__installWrapper__UxUwV
	.BodyHedaer_loaderContainer__progress__ZHQ4y {
	width: 100%;
	height: 5px;
	background-color: rgb(232, 234, 237);
	border-radius: 20px;
	overflow: hidden;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_actions__installWrapper__UxUwV
	.BodyHedaer_loaderContainer__progress__line__E0KKV {
	display: block;
	height: 5px;
	width: 50%;
	background-color: #00a173;
	transition: ease-in-out 0.8s;
}
.BodyHedaer_contentContainer__6We-0
	.BodyHedaer_actions__installWrapper__UxUwV
	.BodyHedaer_loaderContainer__number__9VzqW {
	font-family: "GSMedium";
	font-size: 18px;
	color: #fff;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__YAIYv {
	margin: auto;
	z-index: 1;
	align-items: center;
	display: flex;
	gap: 8px;
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__YAIYv {
		margin: 0;
		padding-left: 16px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share__jYQI4,
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	border: none;
	outline: none;
	color: #00a173;
	font-family: "GSMedium", sans-serif;
	letter-spacing: 0.0107142857em;
	font-size: 0.875rem;
	height: 48px;
	min-width: 48px;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share__jYQI4 div,
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT div {
	display: inline-block;
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share__jYQI4 div,
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT div {
		display: none;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share__jYQI4 svg,
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT svg {
	fill: #00a173;
	margin-right: 8px;
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share__jYQI4 svg,
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT svg {
		margin-right: 0px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT div {
	display: inline-block;
	color: rgb(95, 99, 104);
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT div {
		display: none;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__shareWrapper__share2__cchaT svg {
	fill: rgb(95, 99, 104);
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__trailerWrapper__IKADz {
	display: none;
	margin-left: auto;
	z-index: 10;
}
@container screen and (min-width: 840px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__trailerWrapper__IKADz {
		display: block;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_actions__trailerWrapper__trailer__Qdbr2 {
	position: relative;
	min-height: 40px;
	min-width: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 26px;
	font-family: "GSMedium", sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
	z-index: 1;
	background-color: rgba(0, 0, 0, 0.54);
	border-radius: 48px;
	color: #fff;
	border: none;
	outline: none;
	z-index: 2;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_trailerWrapper__WOAji {
	display: none;
	position: absolute;
	left: 50%;
	top: 0;
	width: 100%;
	height: 240px;
	transform: translateX(-50%);
	justify-content: center;
	align-items: center;
	z-index: 10;
}
@container (max-width: 830px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_trailerWrapper__WOAji {
		display: flex;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_message__ZjMRW {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 16px;
	color: rgb(154, 160, 166);
	padding: 4px 0px;
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0142857143em;
	line-height: 1.25rem;
}
@container screen and (min-width: 600px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_message__ZjMRW {
		padding: 4px 0px;
		align-items: center;
		flex-direction: row;
	}
}
@container screen and (min-width: 1280px) {
	.BodyHedaer_contentContainer__6We-0 .BodyHedaer_message__ZjMRW {
		padding: 4px 0px;
	}
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_message__ZjMRW div:first-child {
	font-size: 20px !important;
	margin-right: 12px;
}
.BodyHedaer_contentContainer__6We-0 .BodyHedaer_trailer__QraXM {
	position: relative;
	min-height: 40px;
	min-width: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 26px;
	font-family: "GSMedium", sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
	z-index: 1;
	background-color: rgba(0, 0, 0, 0.54);
	border-radius: 48px;
	color: #fff;
	border: none;
	outline: none;
	z-index: 2;
}

.Jwxk6d {
	display: grid;
	flex-grow: 1;
	grid-template-columns: 1fr;
}

.HJV0ef {
	padding-bottom: 16px;
}
@container screen and (min-width: 960px) {
	.HJV0ef {
		padding-bottom: 20px;
	}
}
@container screen and (min-width: 1280px) {
	.HJV0ef {
		padding-bottom: 24px;
	}
}

.P4w39d {
	display: flex;
	padding-top: 24px;
}

.Te9Tpc {
	column-gap: 24px;
	display: grid;
	flex-grow: 1;
	grid-template-columns: max-content auto;
}

.jILTFe {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-family: "GSRegular", Roboto, Arial, sans-serif;
	line-height: 4rem;
	font-size: 3.5rem;
	letter-spacing: 0;
	font-weight: 400;
}
.jILTFe :not(:disabled) {
	color: rgb(32, 33, 36);
}

.o9hhOd,
.I26one,
.iXRFPc {
	display: inline-block;
}

.deXnLd {
	height: 16px;
	width: 16px;
}

.Bp7T9b,
.deXnLd,
.F7XJmb {
	display: inline-block;
	text-align: left;
}

.Z1Dz7b {
	color: #01875f;
	fill: #01875f;
	stop-color: #01875f;
}
.Z1Dz7b:not(:disabled) {
	color: #01875f;
}

.EHUI5b {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	font-family: Roboto, Arial, sans-serif;
	line-height: 1rem;
	font-size: 0.75rem;
	letter-spacing: 0.025em;
	font-weight: 400;
	margin-top: 0.5rem;
}
.EHUI5b:not(:disabled) {
	color: rgb(95, 99, 104);
}

.JzwBgb {
	display: grid;
	grid-template-columns: max-content auto;
	align-items: center;
}

.Wi7KIe {
	fill: rgb(241, 243, 244);
	stop-color: rgb(241, 243, 244);
}

.Qjdn7d {
	font-family: Roboto, Arial, sans-serif;
	line-height: 1rem;
	font-size: 0.75rem;
	letter-spacing: 0.025em;
	font-weight: 400;
	padding-right: 16px;
}

.RJfYGf {
	border-radius: 9999px;
	background-color: rgb(232, 234, 237);
	height: 10px;
}
.RJfYGf:not(:disabled) {
	background-color: rgb(232, 234, 237);
}

.RutFAf {
	height: 100%;
	border-radius: inherit;
}

.wcB8se {
	background-color: #01875f;
}
.wcB8se:not(:disabled) {
	background-color: #01875f;
}

.Play_title__XuwTF {
	width: 100%;
}
.Play_title__XuwTF h1 {
	text-align: center;
	color: #fff;
	font-family: "Benzin-Bold", sans-serif;
	font-weight: bold;
	font-size: 97px;
	line-height: 100%;
}
@container (max-width: 1320px) {
	.Play_title__XuwTF h1 {
		font-size: 97px;
	}
}
@container (max-width: 830px) {
	.Play_title__XuwTF h1 {
		font-size: 63px;
	}
}
@container (max-width: 600px) {
	.Play_title__XuwTF h1 {
		font-size: 50px;
	}
}

.Play_container__RJaX9 {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 30px;
}
@container (max-width: 600px) {
	.Play_container__RJaX9 {
		gap: 20px;
	}
}
.Play_container__RJaX9 p {
	font-size: 24px;
	color: #fff;
	text-align: center;
	line-height: 120%;
	font-family: "Benzin-Medium";
	max-width: 920px;
}
.Play_container__RJaX9 p div {
	font-weight: bold;
	font-family: "Benzin-Bold";
}
@container (max-width: 830px) {
	.Play_container__RJaX9 p {
		font-size: 20px;
	}
}
@container (max-width: 600px) {
	.Play_container__RJaX9 p {
		font-size: 12px;
	}
}
.Play_container__RJaX9 .Play_no__uyNVI {
	background-image: linear-gradient(75deg, #140b0a 0%, #311a18 100%);
	width: 300px;
	height: 67px;
	border: none;
	border-radius: 10px;
	outline: none;
	font-family: "Benzin-Bold";
	font-size: 23px;
	text-transform: uppercase;
	color: rgba(255, 255, 255, 0.3019607843);
}
@container (max-width: 830px) {
	.Play_container__RJaX9 .Play_no__uyNVI {
		width: 270px;
		height: 60px;
		font-size: 20px;
	}
}
@container (max-width: 600px) {
	.Play_container__RJaX9 .Play_no__uyNVI {
		width: 136px;
		height: 30px;
		border-radius: 4px;
		font-size: 8px;
	}
}

.Play_notification__qutVj {
	background-image: linear-gradient(75deg, #2b9b2b 0%, #66cc66 100%);
	width: 530px;
	height: 120px;
	border: 3px solid #83ff83;
	border-radius: 17px;
	outline: none;
	font-family: "Benzin-Bold";
	font-size: 29px;
	text-transform: uppercase;
	color: #fff;
}
@container (max-width: 830px) {
	.Play_notification__qutVj {
		width: 500px;
		height: 110px;
		font-size: 23px;
	}
}
@container (max-width: 600px) {
	.Play_notification__qutVj {
		width: 240px;
		height: 54px;
		font-size: 13px;
		border-radius: 8px;
	}
}

.Layout_mobileMenu__G8ipr {
	display: none;
	position: sticky;
	left: 0;
	bottom: 0px;
	background-color: #fff;
	border-top: none;
	bottom: 0;
	width: 100%;
	height: 56px;
	justify-content: center;
	z-index: 10;
	border-top: 1px solid rgb(218, 220, 224);
}

@container (max-width: 840px) {
	.Layout_mobileMenu__G8ipr {
		display: flex;
	}
}

.Layout_mobileMenu__nav__TD3Lc {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.Layout_mobileMenu__item__4RCSH {
	align-items: center;
	display: flex;
	flex: 1 1;
	flex-direction: column;
	justify-content: center;
	max-width: 112px;
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
}

.Layout_mobileMenu__svgContainer__ReFxu {
	display: block;
	line-height: 0;
}

.Layout_mobileMenu__item__4RCSH :not(:disabled) {
	color: rgb(95, 99, 104);
}

.Layout_mobileMenu__G8ipr svg {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
}

.Layout_mobileMenu__item__4RCSH :not(:disabled) {
	color: rgb(95, 99, 104);
}

.Layout_mobileMenu__G8ipr svg:not(:disabled) {
	color: rgb(95, 99, 104);
}

.Layout_mobileMenu__title__tzV1h {
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	line-height: 1.25rem;
	font-size: 0.875rem;
	letter-spacing: 0.0178571429em;
	font-weight: 500;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

.Layout_mobileMenu__title__tzV1h:nth-child(2) {
	color: #01875f !important;
	fill: #01875f !important;
	stop-color: #01875f !important;
}

.Layout_mobileMenu__item__4RCSH :not(:disabled) {
	color: rgb(95, 99, 104);
}

.Layout_videoPopup__1wQNU {
	display: none;
	transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0.15s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 5000;
	transition: opacity 0.05s cubic-bezier(0.4, 0, 0.2, 1);
	opacity: 1;
	background-color: rgb(0, 0, 0);
}

.open {
	display: block;
}

.Layout_videoPopup__content__Nfb77 {
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.Layout_videoPopup__close__vLDXo {
	position: absolute;
	left: 20px;
	top: 20px;
	z-index: 10;
	cursor: pointer;
}

.Layout_videoPopup__close__vLDXo div {
	width: 40px;
	height: 40px;
	font-size: 40px;
	color: white;
}

.Layout_imagePopup__CCOgX {
	display: none;
	transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0.15s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 5000;
	transition: opacity 0.05s cubic-bezier(0.4, 0, 0.2, 1);
	opacity: 1;
	background-color: rgba(0, 0, 0, 0.7);
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
}

.openImage {
	display: flex;
}

.Layout_imagePopup__header__n7kd7 {
	align-items: center;
	display: flex;
	height: 64px;
	background-color: #000;
	width: 100%;
}

.Layout_imagePopup__header__n7kd7 button {
	background-color: transparent;
	border: none;
	outline: none;
	width: 48px;
	height: 48px;
	margin-left: 16px;
	color: #e8eaed;
	cursor: pointer;
}

.Layout_imagePopup__body__nwj57 {
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.Gallery_buttonNext__NwwV {
	right: 0;
	top: 50%;
	transform: translateX(50%) translateY(-50%);
}

.Gallery_buttonPrev__GjkHI,
.Gallery_buttonNext__NwwV {
	position: absolute;
	min-width: 40px;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: 56px;
	height: 56px;
	padding: 0;
	border: none;
	border-radius: 50%;
	background-color: #fff;
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
	color: rgb(95, 99, 104);
	font-size: 24px;
	fill: currentColor;
	text-decoration: none;
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	overflow: visible;
	transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 15ms linear 30ms,
		transform 0.27s 0ms cubic-bezier(0, 0, 0.2, 1);
}

@container (max-width: 600px) {
	.Gallery_buttonPrev__GjkHI,
	.Gallery_buttonNext__NwwV {
		display: none;
	}
}

.Layout_buttonNext__p4gU9 {
	position: absolute !important;
	right: 32px !important;
	width: 48px !important;
	height: 48px !important;
	transform: translateX(0%) translateY(-50%) !important;
	display: flex;
	z-index: 20 !important;
}

.Layout_buttonPrev__IU3Mn {
	position: absolute !important;
	left: 32px !important;
	width: 48px !important;
	height: 48px !important;
	transform: translateX(0%) translateY(-50%) !important;
	display: flex;
	z-index: 20 !important;
}

.Gallery_buttonNext__NwwV > div {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 30px;
	font-weight: 200;
	width: 36px;
	height: 36px;
}

.Layout_imagePopup__body__nwj57 img {
	max-height: 90%;
	max-width: 80%;
	object-fit: contain;
	z-index: 10;
	background-size: contain;
	width: 100%;
}

.Layout_comentsPopup__aCryR {
	display: none;
	transition: opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0.15s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 5000;
	transition: opacity 0.05s cubic-bezier(0.4, 0, 0.2, 1);
	opacity: 1;
	background-color: rgba(32, 33, 36, 0.6);
	justify-content: center;
	align-items: center;
}

.Layout_comentsPopup__container__-HmxJ {
	display: flex;
	flex-direction: column;
	height: calc(100vh - 32px);
	max-height: 720px;
	max-width: 720px;
	width: calc(100% - 32px);
	background-color: #fff;
	border-radius: 8px;
}

.Layout_comentsPopup__header__tpoa4 {
	display: flex;
	flex-shrink: 0;
	padding: 24px 32px;
}

.Layout_comentsPopup__header__content__IT2Pe {
	align-items: center;
	display: flex;
	flex-grow: 1;
}

.Layout_comentsPopup__header__content__IT2Pe img {
	height: 48px;
	width: 48px;
	border-radius: 8px;
	box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.09), 0 3px 5px rgba(0, 0, 0, 0.06),
		0 1px 2px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.15);
	flex-shrink: 0;
	margin-right: 16px;
	background-size: contain;
}

.Layout_comentsPopup__header__content__IT2Pe h5 {
	color: rgb(32, 33, 36);
	fill: rgb(32, 33, 36);
	stop-color: rgb(32, 33, 36);
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	line-height: 1.75rem;
	font-size: 1.375rem;
	letter-spacing: 0;
	font-weight: 400;
	font-weight: 500;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	display: -webkit-box;
	overflow: hidden;
}

.Layout_comentsPopup__header__content__IT2Pe h5:not(:disabled) {
	color: rgb(32, 33, 36);
}

.Layout_comentsPopup__header__subTitle__Ms79I {
	color: rgb(95, 99, 104);
	fill: rgb(95, 99, 104);
	stop-color: rgb(95, 99, 104);
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	display: -webkit-box;
	overflow: hidden;
	font-size: 0.875rem;
	font-weight: 400;
	letter-spacing: 0.0178571429em;
	line-height: 1.25rem;
	line-height: 1.75rem;
}

.Layout_comentsPopup__header__subTitle__Ms79I:not(:disabled) {
	color: rgb(95, 99, 104);
}

.blockHeader {
	position: relative;
	display: flex;
	align-items: center;
	color: rgb(32, 33, 36);
	padding-bottom: 20px;
}

.blockHeader > button {
	margin: -11px;
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	border: none;
	border-radius: 50%;
	outline: none;
	font-family: "GSMedium", sans-serif;
	font-size: 100%;
	cursor: pointer;
}

.blockHeader > button div {
	color: rgb(95, 99, 104);
	font-size: 24px;
}

.Layout_comentsPopup__body__I3tgc {
	flex-grow: 1;
	margin: 0 32px;
	overflow: scroll;
	padding-bottom: 28px;
	scrollbar-width: none;
}

.Layout_comentsPopup__body__container__Lhq7g {
	display: grid;
	grid-template-columns: auto;
	min-height: 100%;
}

.Layout_comentsPopup__body__buttons__GbPup {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
}

.buttonFromGroup._custom {
	background-color: #e6f3ef;
	color: #056449;
	border: none !important;
}
.buttonFromGroup {
	min-height: auto;
	padding: 0 15px 0 15px;
	height: 32px;
	margin-top: 0;
	margin-bottom: 0;
	outline: none;
	border-style: solid;
	border-radius: 16px;
	border-width: 1px;
	border-color: rgb(218, 220, 224);
	color: rgb(95, 99, 104);
	background-color: transparent;
	font-family: "GSMedium", Roboto, Arial, sans-serif;
	font-size: 0.875rem;
	letter-spacing: 0.0107142857em;
	font-weight: 500;
	text-transform: none;
	transition: border 0.28s cubic-bezier(0.4, 0, 0.2, 1),
		box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
	box-shadow: none;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.buttonFromGroup > div {
	margin: 0 4px 0 0;
	font-size: 16px;
	width: 16px;
	height: 16px;
}

.BodyHedaer_actions__installWrapper__verifying__LvZ {
	background-color: rgb(154, 160, 166) !important;
	color: #42454b !important;
	display: flex;
	justify-content: center !important;
	align-items: center !important;
	gap: 10px !important;
}

.BodyHedaer_actions__installWrapper__verifying__LvZ > div {
	display: block;
	width: 20px;
	padding: 2px;
	aspect-ratio: 1;
	border-radius: 50%;
	background: #42454b;
	--_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
	-webkit-mask: var(--_m);
	mask: var(--_m);
	-webkit-mask-composite: source-out;
	mask-composite: subtract;
	animation: loader 1s infinite linear;
}
@keyframes loader {
	to {
		transform: rotate(1turn);
	}
}

.loaderContainer {
	position: relative;
	width: 100%;
	height: 100dvh;
	display: flex;
	justify-content: center;
	align-items: center;
}

.loader2 {
	width: 48px;
	height: 48px;
	border: 5px solid #00a173;
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

        `}</style>
        </root.div>
      </div>
    </>
  );
};

export default GoogleplaySite;
